import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../hooks/usePageTitle';
import { capitalizeFirstLetter } from '../utils/capitalize';

const NotFoundPage: React.FC = () => {
    const { t } = useTranslation();
    usePageTitle(capitalizeFirstLetter(t('notFound')));
    return (
        <div className="fx-c fx-items-c fx-justify-sa h-100">
            <img src={require('../assets/images/errors/404.png')} />
        </div>
    );
};

export default NotFoundPage;
